module.exports = __webpack_public_path__ + "static/media/uber.59cebad2.svg";